
import React, { useEffect, useState, useCallback } from "react";

import { aquaticCenters, communityCenters, parkBuildings, parks } from '../common/data';


const GeoCode = () => {
  const [centersWithCoords, setCentersWithCoords] = useState([]);

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY; // or your API key

  const geocodePlace = useCallback(async (placeName) => {
  // To reduce ambiguity, add the county and state
  const address = `${placeName}, Prince George's County, MD`;

  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    address
  )}&key=${apiKey}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.status === "OK" && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;
      return { lat, lng };
    } else {
      console.warn(`Geocoding failed for "${placeName}":`, data.status);
      return null;
    }
  } catch (error) {
    console.error(`Error fetching geocode for "${placeName}":`, error);
    return null;
  }
}, [apiKey]);


  const fetchAllCoordinates = useCallback(async () => {
    const promises = parks.map(async (center) => {
      const coords = await geocodePlace(center.name);
      return {
        ...center,
        lat: coords?.lat ?? null,
        lng: coords?.lng ?? null,
      };
    });

    const results = await Promise.all(promises);
    setCentersWithCoords(results);
  }, [geocodePlace]);

  useEffect(() => {
    fetchAllCoordinates();
  }, [fetchAllCoordinates]);

  //check duplicate
  const findDuplicates = (arr, key) =>{
    const map = new Map();
    const dupes = [];
    for(const item of arr){
      if(map.has(item[key])){
        dupes.push(item)
      } else {
        map.set(item[key], true);
      }
    }
    return dupes;
  }
const arr = [ ...aquaticCenters, ...communityCenters, ...parkBuildings, ...parks]
const duplicates = findDuplicates(arr, "name");
console.log('Array: ', arr)
console.log('duplicates:' ,duplicates)
console.log(parks.length)

  return (
    <div>
      <h3>Parks with Coordinates</h3>
      <pre>{JSON.stringify(centersWithCoords, null, 2)}</pre>
    </div>
  );
};

export default GeoCode;